import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import DocumentGenerator from '../components/DocumentGenerator';
import { getToken } from '../utils/auth';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const TCPage = () => {
  const { schoolId } = useParams();
  const [templateId, setTemplateId] = useState(null);
  const [loading, setLoading] = useState(true);
  const token = getToken(schoolId);

  useEffect(() => {
    fetch(`${API_URL}/documents/school-config`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => {
        if (d.success) {
          const tc = d.data.find(c => c.docType === 'TC');
          if (tc) setTemplateId(tc.templateId);
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div style={{ padding: 40, textAlign: 'center', color: '#888' }}>Loading...</div>;

  return (
    <div>
      <header className="dash-topbar">
        <div>
          <h1 className="page-title">Transfer Certificate</h1>
          <p className="page-subtitle">Search student, fill details, and generate TC</p>
        </div>
      </header>
      <DocumentGenerator docType="TC" templateId={templateId} />
    </div>
  );
};

export default TCPage;
